module.exports = __webpack_public_path__ + "img/Picture22.dc82fac9.png";